export const SLIDER_ITEM_TYPES = {
  HTML_SNIPPET: 'HTML snippet',
  IMAGE: 'Image'
};

export const ROTATION_TYPES = {
  PAGES: 'pages', // full width slide, no padding
  SLIDES: 'slides' // 90% width slide + paddings around carousel
};
